import React, { Component } from 'react';
import './Svg.scss';
import './Icon.scss';

export default class Icon {
    static buildCssClass(props) {
        const { className, colorIndex, hoverColorIndex, size } = props;
        let colorClass = 'color--' + colorIndex;
        let hoverColorClass = 'hover-color--' + hoverColorIndex;
        let sizeClass = 'size--' + size;
        let finalClassName = "Icon " + className + " " + sizeClass + " " + colorClass + " " + hoverColorClass;

        return finalClassName;
    }
}



// WEBPACK FOOTER //
// ./src/components/icon/Icon.js